import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Row, Col, Panel, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { findBootstrapEnvironment } from '../helpers/utils';
import { colorMap } from './../helpers/colors';

class Cards extends PureComponent {
    render() {
        const {
            cards = [],
            cardStats = {},
            cardColor = () => `rgba( ${colorMap['blue']}, 0.3 )`,
            config,
            id,
            selectedCard = undefined,
            cardSizes = {
                xs: 6,
                md: 3,
                lg: 2
            },
            enabledCards = undefined,
        } = this.props;

        let cardGlyph = this.props.cardGlyph || 'inbox';

        const size = findBootstrapEnvironment();

        let selectedCardValue = selectedCard;
        if (_.isObject(selectedCard)) {
            selectedCardValue = selectedCard.value;
        }

        return (
            <div>
            <div id={id} className="case-cards">
            {cards.map((card) => {
                let overlayStyle;
                let cardLabel = card;
                let cardValue = card;                
                let icon;
                if (_.isObject(card)) {
                    cardLabel = card.label;
                    cardValue = card.value;
                    if (card.glyph) {
                        icon = <Glyphicon glyph={card.glyph}  />;
                    } else if (card.img) {
                        icon = <img src={card.img} />;
                    }

                } else {
                    icon = <Glyphicon glyph={cardGlyph}  />;
                }

                let enabled = true;
                if (enabledCards !== undefined && !enabledCards.find(v => _.isEqual(v, card))) {
                    enabled = false;
                    cardLabel = <span><Glyphicon glyph='ban-circle' style={{ marginRight: 10 }} />{cardLabel}</span>
                    overlayStyle = {
                        position: 'relative',
                        zIndex: 1,
                        backgroundColor: 'rgba( 86, 86, 86, 1.0)',
                        backgroundSize: 'cover',
                    };

                } else if (selectedCardValue !== undefined && selectedCardValue !== cardValue) {
                    overlayStyle = {
                        position: 'relative',
                        zIndex: 1,
                        backgroundColor: 'rgba( 128, 128, 128, 1.0)',
                        backgroundSize: 'cover',
                    };
                }

                const dimmed = !enabled || (selectedCardValue !== undefined && selectedCardValue !== cardValue);
                const swatchColor = cardColor(card, config);
                const stateClass = !enabled ? ' is-disabled' : (dimmed ? ' is-dimmed' : '');

                let content = (
                        <div className={`case-card${stateClass}${swatchColor === '#5b6676' ? ' is-inverse' : ''}`}
                             style={{ cursor: enabled ? 'pointer' : 'not-allowed' }}
                             key={String(cardValue)}
                             onClick={(evt) => {
                                 evt.preventDefault();
                                 if (enabled) {
                                     this.props.onClick(card);
                                 }
                             }}
                        >
                            <span className="case-card__swatch" style={{ backgroundColor: swatchColor }}>{icon}</span>
                            <span className="case-card__text">
                                <span className="case-card__label">{cardLabel}</span>
                                <span className="case-card__count">{cardStats[cardValue] || 0}</span>
                            </span>
                        </div>
                );

                if (!__IS_MOBILE__ && enabled) {
                    content = (
                        <OverlayTrigger key={String(cardValue)} placement="top"
                                        trigger={['hover', 'focus']}
                                        overlay={(<Tooltip id="tooltip">Show only '{cardLabel}'</Tooltip>)}>
                            {content}
                        </OverlayTrigger>
                    );
                }

                return content;
            })}
            </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let config = state.user.config;
    return {
        config
    };
};

export default connect(mapStateToProps)(Cards);
